import React from 'react'
import { Paper } from '@material-ui/core'
import usePointrThemedPaperFormStyle from './Styles'
import { IPointrThemedPaperForm } from './Interfaces'
import cx from 'classnames'

const PointrThemedPaperForm: React.FC<IPointrThemedPaperForm> = ({
  title,
  subTitle,
  onSubmit,
  children,
  justifyContent,
  alignItems,
  className
}) => {
  const classes = usePointrThemedPaperFormStyle({
    justifyContent,
    alignItems
  })

  return (
    <Paper className={className ? cx(classes.paper, className) : classes.paper}>
      <form onSubmit={onSubmit} className={classes.column}>
        {title && subTitle && (
          <h3 id="pointr-form-title" className={classes.formTitle}>
            {title}
            <br />
            {subTitle}
          </h3>
        )}
        {title && !subTitle && (
          <h3 id="pointr-form-title" className={classes.formTitle}>
            {title}
          </h3>
        )}
        {children}
      </form>
    </Paper>
  )
}

PointrThemedPaperForm.defaultProps = {
  title: '',
  subTitle: '',
  justifyContent: 'center',
  alignItems: 'center',
  className: ''
}

export default PointrThemedPaperForm
